/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdatePenaltyCommand } from '../../models/update-penalty-command';
import { UpdatePenaltyCommandResult } from '../../models/update-penalty-command-result';

export interface ApiPenaltiesUpdatePenaltyPatch$Params {
      body?: UpdatePenaltyCommand
}

export function apiPenaltiesUpdatePenaltyPatch(http: HttpClient, rootUrl: string, params?: ApiPenaltiesUpdatePenaltyPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdatePenaltyCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiPenaltiesUpdatePenaltyPatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdatePenaltyCommandResult>;
    })
  );
}

apiPenaltiesUpdatePenaltyPatch.PATH = '/api/Penalties/UpdatePenalty';
